var map = {
	"./1.jpg": 28,
	"./10.jpg": 37,
	"./11.jpg": 27,
	"./2.jpg": 29,
	"./3.jpg": 30,
	"./4.jpg": 31,
	"./5.jpg": 32,
	"./6.jpg": 33,
	"./7.jpg": 34,
	"./8.jpg": 35,
	"./9.jpg": 36
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 324;